import React, { useState, useEffect } from 'react';
import { Autocomplete, Chip, Grid, TextField } from '@mui/material';
import APIUtils from '../../../../utils/APIUtils';
import muiInputStyles from '../../../../uiComponents/MuiInput/MuiInputStyles';

import './index.css';

export default function VariantInterpretationTags(props) {
  const classes = muiInputStyles();
  const [availableTags, setAvailableTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTags();
  }, []);

  useEffect(() => {
    if (availableTags.length > 0 && props.savedTagIds && props.savedTagIds.length > 0) {
      const preselected = availableTags.filter(tag => props.savedTagIds.includes(tag.tagId));
      setSelectedTags(preselected);
    }
  }, [availableTags, props.savedTagIds]);

  async function fetchTags() {
    try {
      const response = await APIUtils.getTags();
      setAvailableTags(response || []);
    } catch (err) {
      console.error('Error fetching tags:', err);
    } finally {
      setLoading(false);
    }
  }

  const handleTagChange = (event, newValue) => {
    setSelectedTags(newValue);
    const tagIds = newValue.map(tag => tag.tagId);
    props.onTagsChange(tagIds);
  };

  return (
    <section className="section">
      <h2 className="sectionHeading">Variant Interpretation Tags</h2>
      <div className="sectionContent">
        {props.readOnly ? (
          <div className="tagsReadOnly">
            {selectedTags.length > 0 ? (
              selectedTags.map(tag => (
                <Chip
                  key={tag.tagId}
                  label={tag.tagName}
                  size="small"
                  className="tagPill"
                />
              ))
            ) : (
              <span className="noTags">No tags</span>
            )}
          </div>
        ) : (
          <Grid container spacing={0}>
            <Grid item md={3} sm={2} />
            <Grid item md={6} sm={8} xs={12}>
              <div className="tagsSelect">
                <Autocomplete
                  multiple
                  fullWidth
                  size="small"
                  id="variant-interpretation-tags"
                  className={classes.muiInputs}
                  options={availableTags}
                  getOptionLabel={(option) => option.tagName || ''}
                  value={selectedTags}
                  onChange={handleTagChange}
                  loading={loading}
                  isOptionEqualToValue={(option, value) => option.tagId === value.tagId}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.tagId}
                        label={option.tagName}
                        size="small"
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Tags"
                      placeholder="Select tags"
                    />
                  )}
                  disabled={props.disabled}
                />
              </div>
            </Grid>
            <Grid item md={3} sm={2} />
          </Grid>
        )}
      </div>
    </section>
  );
}
